var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-second-gg-content"},[_vm._v(" "+_vm._s(_vm.rowData.body)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }